import React from 'react'
import { Button, Result } from 'antd'
import { Link } from 'umi'

const NoAccess: React.FC = () => (<Result
  status={ 403 }
  title='无页面访问权限'
  subTitle='对不起，您暂时没有该页面的权限，请联系管理员添加！'
  extra={
    <Button type='primary'>
      <Link to={ LoginPath }>返回登录页</Link>
    </Button>
  }
/>)
export default NoAccess
